import { child } from "@splidejs/splide/src/js/utils";

window.oxgLastFormLikeId = 0;

/*
   #ANCHOR Helpers
*/

const getItems = (selector)=> {
  let items = document.querySelectorAll(selector);
  if (items) return items
}

const maybeInit = (selector, initFn)=> {
  let items = getItems(selector)
  if(items && initFn) {
    initFn(items)
  }
}

/*
   #ANCHOR User Selectable List Items
*/

const deselectUserSelectableListItem = (item) => {
  item.classList.remove('is-selected')
  item.setAttribute('aria-selected', 'false')
  let childCheckboxes = oxgGetCheckboxes(item)
  if (childCheckboxes) {
    oxgUncheckAll(childCheckboxes)
  }
}

const selectUserSelectableListItem = (item) => {
  item.classList.add('is-selected')
  item.setAttribute('aria-selected', 'true')
  let childCheckboxes = oxgGetCheckboxes(item)
  if (childCheckboxes) {
    oxgCheckAll(childCheckboxes)
  }
}

const initUserSelectableListItems = (items) => {
  Array.from(items).forEach(item => {
    let formLikeId = item.getAttribute('data-formlike-id')
    if(!formLikeId) {

      //only init item if not yet done. Initialized items have a Formlike ID
      oxgLastFormLikeId++
      item.setAttribute('data-formlike-id', oxgLastFormLikeId)

      //mouse event
      item.addEventListener('click', ()=> {
        if (item.classList.contains('is-selected')) {
          deselectUserSelectableListItem(item)
        } else {
          selectUserSelectableListItem(item)
        }
      })

      //keyboard event
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault() //prevent scrolling
            this.click()
          }
      })

    }
  });
}

/*
   #ANCHOR DOMContentLoaded
*/

document.addEventListener('DOMContentLoaded', () => {

  //User Selectable List Items
  maybeInit('.list-item-user-selectable', initUserSelectableListItems)
  document.addEventListener('oxgModalOpen', ()=> {
    maybeInit('.list-item-user-selectable', initUserSelectableListItems)
  })

  //Add more form like elements here as needed
  //...
});